import 'core-js/modules/es.object.assign.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { styled, Stack, withUtility, css, Box, Text } from '@hub-la/design-system';
import { Thumbnail } from '@hub-la/fe-thumbnail';
import Countdown from 'react-countdown';
import { useHistory } from 'react-router-dom';
import { GetPostPagination } from '../../../usecases/get-post-pagination.js';
import { PaginationHelper } from '../../../usecases/pagination-helper.js';
import { useRealtimeSections } from '../../hooks/use-realtime-sections.js';
import '@hub-la/fe-container';
import '@hub-la/fe-core-http-client';
import 'react-query';
import '../../../usecases/save-file.js';
import '../../../domain/dtos/query-key.js';
import '../../../usecases/save-post.js';
import 'react';
import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/web.dom-collections.iterator.js';

let _ = t => t,
  _t,
  _t2;
const COUNTDOWN_IN_SECONDS = 7;
const StackWithGradient = styled(Stack)(_t || (_t = _`
  @keyframes progressCardAnimation {
    0% {
      background-size: 0% 100%;
    }
    100% {
      background-size: 100% 100%;
    }
  }

  animation-timing-function: ease;
  animation: progressCardAnimation ${0}s linear;
  ${0}
`), COUNTDOWN_IN_SECONDS + 1, withUtility(({
  palette
}) => {
  return css(_t2 || (_t2 = _`
      background: linear-gradient(${0}, ${0}) left no-repeat,
        ${0};
    `), palette('surfaceVariant'), palette('surfaceVariant'), palette('surface'));
}));
const UpNextCard = ({
  postId
}) => {
  var _a;
  const history = useHistory();
  const {
    sections
  } = useRealtimeSections();
  const pagination = new GetPostPagination().execute({
    postId,
    sections
  });
  const {
    nextPost
  } = PaginationHelper.getPaginationData(sections, postId, pagination);
  if (!nextPost) return null;
  const handleRedirectPost = () => {
    const postLink = `/post/${nextPost.id}`;
    history.push(postLink);
  };
  return jsx(Box, Object.assign({
    "data-testid": "upnext-card",
    maxWidth: 305,
    zIndex: 1,
    position: "absolute",
    top: "50%",
    left: "50%",
    style: {
      transform: 'translate(-50%, -50%)'
    }
  }, {
    children: jsxs(StackWithGradient, Object.assign({
      style: {
        cursor: 'pointer'
      },
      onClick: handleRedirectPost,
      p: 2,
      direction: "row",
      gap: 3,
      borderRadius: 1,
      alignItems: "center",
      maxWidth: 305,
      width: "100%",
      minWidth: 305
    }, {
      children: [jsx(Thumbnail, {
        hasProgressBar: false,
        width: 94,
        height: 156,
        asset: (_a = nextPost.customCover) !== null && _a !== void 0 ? _a : nextPost.cover
      }), jsxs(Stack, {
        children: [jsx(Text, Object.assign({
          variant: "h4",
          mb: 4,
          color: "neutralPrimary"
        }, {
          children: nextPost === null || nextPost === void 0 ? void 0 : nextPost.title
        })), jsxs(Text, Object.assign({
          variant: "body2",
          color: "neutralPrimary"
        }, {
          children: ["Pr\u00F3ximo em", ' ', jsx("strong", {
            children: jsx(Countdown, {
              date: Date.now() + COUNTDOWN_IN_SECONDS * 1000,
              onComplete: handleRedirectPost,
              renderer: ({
                seconds
              }) => `${seconds}`
            })
          })]
        }))]
      })]
    }))
  }));
};

export { UpNextCard as default };
